/**
 * Global state manager for modals opened from alert items
 * This allows modals to persist even when the alert component unmounts
 */
const alertModalsState = {
  openModals: new Map(), // Map<alertId, { generationData, onClose }>
};

export const openAlertModal = (alertId, generationData, onClose) => {
  alertModalsState.openModals.set(alertId, { generationData, onClose });
  // Trigger re-render by dispatching a custom event
  window.dispatchEvent(new CustomEvent("alertModalStateChanged"));
};

export const closeAlertModal = (alertId) => {
  alertModalsState.openModals.delete(alertId);
  window.dispatchEvent(new CustomEvent("alertModalStateChanged"));
};

export const getOpenAlertModals = () => {
  return Array.from(alertModalsState.openModals.entries()).map(
    ([alertId, data]) => ({
      alertId,
      ...data,
    })
  );
};

export default alertModalsState;
